import ForumsService from '../../api/forums'
import sharedActions from '../shared/actions'

export default {
  ...sharedActions,
  getThreads: async function({commit}, {url}) {
    const response = await ForumsService.getThreads({url, page: 1})
    commit('setThreads', response.data)
    commit('setPagination', {currentPage: response.meta.page, totalPages: response.meta.totalPages})
  },
  getMoreThreads: async function({state, commit}, url) {
    const response = await ForumsService.getThreads({url, page: state.pagination.currentPage + 1})
    commit('setMoreThreads', response.data)
    commit('setPagination', {currentPage: response.meta.page, totalPages: response.meta.totalPages})
  },
  createThread: async function({commit}, {url, title, messageAttributes}) {
    const response = await ForumsService.createThread(url, {title, messageAttributes})
    commit('setCreatedThread', response)
  }
}
